import styled from 'styled-components';
import { flexbox, space, layout, position } from 'styled-system';

export const Box = styled.div`
  box-sizing: border-box;
  ${space}
  ${layout}
  ${flexbox}
`;

export const Flex = styled(Box).attrs({
  display: 'flex',
})``;

export const Absolute = styled(Box)`
  position: absolute;
  ${position}
`;
